import React from 'react';
import { helpers } from '../services/helpers';
import { api } from '../services/api';
import { useNavigate } from 'react-router-dom';
import ProfileImage from './ProfileImage.js';
import ProfileHover from './ProfileHover';
import Tooltip from './Tooltip.js';

function Notifications({ notifications, loadNotifications }) {
  const navigate = useNavigate();
  const readNotification = (i, e) => {
    if (e.target.closest('.tooltip-2-container') || e.target.closest('.tooltip-2-text')) {
      return;
    }
    if (notifications[i].commentId) {
      api.readReply(notifications[i].id).then(loadNotifications);
    } else {
      api.readComment(notifications[i].id).then(loadNotifications);
    }
    navigate(`/surgeries?surgery=${notifications[i].reviewId}&comment=${notifications[i].id}`);
  };

  const readAllNotifications = () => {
    api.readAllNotifications().then(loadNotifications)
  }

  return (
    <div className="notifications-container">
      <h2 style={{ textAlign: 'left', display: 'flex', justifyContent: 'space-between' }} className="notifications-header">
        <div style={{ color: '#5C6C74' }}>Notifications</div>
        {
          notifications.filter(notification => !notification.isRead).length > 0 && (
            <div style={{ color: '#000000', cursor: 'pointer' }} onClick={readAllNotifications}>Mark all as read</div>
          )
        }
      </h2>
      {(!notifications || notifications?.length == 0) && (
        <div className="empty-state">
          <p>You do not have any notifications at this time.</p>
        </div>
      )}
      {notifications && notifications.map((notification, index) => {
        return (
          <div
            onClick={(e) => readNotification(index, e)}
            className={`notification-card ${notification.isRead ? '' : 'active'}`}
            key={notification.id}
            style={{ padding: '0.5rem 1rem' }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <Tooltip content={<ProfileHover profile={notification.patient} />}>
                  <ProfileImage profile={notification.patient} size={30} />
                </Tooltip>
                <div style={{ display: 'flex', flexDirection: 'column', paddingLeft: '4px' }}>
                  <Tooltip content={<ProfileHover profile={notification.patient} />}>
                    <p style={{ fontWeight: 'bold', fontSize: '14px' }}>{notification.patient.username}</p>
                  </Tooltip>
                  <div className="review-date" style={{ fontSize: '12px' }}>
                    {helpers.formatUpdatedAt(notification.createdAt)}
                  </div>
                </div>
              </div>
            </div>
            <div className="notification-card-header" style={{ fontSize: '14px' }}>
              {notification.commentId ? 'Replied to your comment' : 'Commented on your Surgery'}
            </div>
            <p className="notification-description">{notification.text}</p>
          </div>
        )
      })}
    </div>
  );
}

export default Notifications; 